// 修改密码浮层 / Change-password modal.
import { authApi as defaultAuthApi } from "@/api/auth";
import { startButtonLoading } from "@/features/async-button";

interface Deps {
  authApi: Pick<typeof defaultAuthApi, "changePassword">;
}
const DEFAULT_DEPS: Deps = { authApi: defaultAuthApi };

export function openChangePasswordModal(deps: Partial<Deps> = {}): void {
  const d = { ...DEFAULT_DEPS, ...deps };
  const root = document.getElementById("change-pwd-modal");
  if (!root) throw new Error("#change-pwd-modal mount missing");
  root.hidden = false;
  root.innerHTML = `
    <div class="overlay"></div>
    <div class="modal">
      <h3>Change password</h3>
      <form>
        <input name="old" type="password" placeholder="Current password" />
        <input name="new" type="password" placeholder="New password" />
        <input name="confirm" type="password" placeholder="Confirm new password" />
        <div class="err" hidden></div>
        <div class="actions">
          <button type="button" class="btn-cancel">Cancel</button>
          <button type="button" class="btn-confirm">Update password</button>
        </div>
      </form>
    </div>
  `;
  const close = () => { root.hidden = true; root.innerHTML = ""; };
  root.querySelector(".btn-cancel")?.addEventListener("click", close);
  root.querySelector(".btn-confirm")?.addEventListener("click", async () => {
    const form = root.querySelector<HTMLFormElement>("form")!;
    if (form.dataset.busy === "1") return;
    const err = form.querySelector<HTMLElement>(".err")!;
    const button = form.querySelector<HTMLButtonElement>(".btn-confirm")!;
    err.hidden = true;
    const oldP = (form.elements.namedItem("old") as HTMLInputElement).value;
    const newP = (form.elements.namedItem("new") as HTMLInputElement).value;
    const confirm = (form.elements.namedItem("confirm") as HTMLInputElement).value;
    if (!/^(?=.*[A-Za-z])(?=.*\d).{8,}$/.test(newP)) {
      err.hidden = false; err.textContent = "Password must be at least 8 characters and include letters and numbers."; return;
    }
    if (newP !== confirm) {
      err.hidden = false; err.textContent = "Passwords do not match."; return;
    }
    const restore = startButtonLoading(button, "Updating");
    form.dataset.busy = "1";
    try {
      await d.authApi.changePassword({ old_password: oldP, new_password: newP });
      close();
    } catch (e: any) {
      err.hidden = false;
      err.textContent = e?.code === "LOGIN_FAILED"
        ? "Current password is incorrect."
        : (e?.message || "Password update failed.");
    } finally {
      delete form.dataset.busy;
      restore();
    }
  });
}
